export enum eventFiltersTypes {
  CREDIT_ANALYSIS = 'CREDIT_ANALYSIS',
  FUNDS_ANALYSIS = 'FUNDS_ANALYSIS',
  ESG_ANALYSIS = 'ESG_ANALYSIS',
}
